// Animate hidden object in with a fade effect


$(document).ready( function() {
    function animateObject0() {
        // Define your object via class.
        var fadeinelement = $('.fadeIn-effect');
        // Exit early if no objects on page.
        if (fadeinelement.length == 0) {
            return;
        }
        // Loop through each object in the array.
        $.each( fadeinelement, function() {
            var windowHeight = $(window).height(),
                offset 		 = $(this).offset().top,
                top			 = offset - $(document).scrollTop(),
                percent 	 = Math.floor( top / windowHeight * 100 );
            if ( percent < 85 ) {
                $(this).addClass( 'fadeIn' );
            }
        });
    }
    function animateObject1() {
        // Define your object via class.
        var fadeinupelement = $('.fadeInUp-effect');
        // Exit early if no objects on page.
        if (fadeinupelement.length == 0) {
            return;
        }
        // Loop through each object in the array.
        $.each( fadeinupelement, function() {
            var windowHeight = $(window).height(),
                offset 		 = $(this).offset().top,
                top			 = offset - $(document).scrollTop(),
                percent 	 = Math.floor( top / windowHeight * 100 );
            if ( percent < 85 ) {
                $(this).addClass( 'fadeInUp' );
            }
        });
    }
    function animateObject2() {
        // Define your object via class.
        var fadeinrightelement = $('.fadeInRight-effect');
        // Exit early if no objects on page.
        if (fadeinrightelement.length == 0) {
            return;
        }
        // Loop through each object in the array.
        $.each( fadeinrightelement, function() {
            var windowHeight = $(window).height(),
                offset 		 = $(this).offset().top,
                top			 = offset - $(document).scrollTop(),
                percent 	 = Math.floor( top / windowHeight * 100 );
            if ( percent < 85 ) {
                $(this).addClass( 'fadeInRight' );
            }
        });

    }
    function animateObject3() {
        // Define your object via class.
        var fadeinleftelement = $('.fadeInLeft-effect');
        // Exit early if no objects on page.
        if (fadeinleftelement.length == 0) {
            return;
        }
        // Loop through each object in the array.
        $.each( fadeinleftelement, function() {
            var windowHeight = $(window).height(),
                offset 		 = $(this).offset().top,
                top			 = offset - $(document).scrollTop(),
                percent 	 = Math.floor( top / windowHeight * 100 );
            if ( percent < 85 ) {
                $(this).addClass( 'fadeInLeft' );
            }
        });
    }
    function animateObject4() {
        // Define your object via class.
        var fadeindownelement = $('.fadeInDown-effect');
        // Exit early if no objects on page.
        if (fadeindownelement.length == 0) {
            return;
        }
        // Loop through each object in the array.
        $.each( fadeindownelement, function() {
            var windowHeight = $(window).height(),
                offset 		 = $(this).offset().top,
                top			 = offset - $(document).scrollTop(),
                percent 	 = Math.floor( top / windowHeight * 100 );
            if ( percent < 85 ) {
                $(this).addClass( 'fadeInDown' );
            }
        });
    }

    $(window).on('load', function() { // Run functions on page load
        animateObject0;
        animateObject1;
        animateObject2;
        animateObject3;
        animateObject4;
    });
    $(window).scroll(animateObject0); // Run 'animateObject0' function on page scroll
    $(window).scroll(animateObject1); // Run 'animateObject1' function on page scroll
    $(window).scroll(animateObject2); // Run 'animateObject2' function on page scroll
    $(window).scroll(animateObject3); // Run 'animateObject3' function on page scroll
    $(window).scroll(animateObject4); // Run 'animateObject4' function on page scroll

})